import React from 'react'
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '672px',
    maxHeight: 'calc(100vh - 78.5px)',
};

const styledMap = [
    { "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] },
    { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
    { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] },
    { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] },
    { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] },
    { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] },
    { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] },
    { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] },
    { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] },
    { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] },
    { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] },
    { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] },
    { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] },
    { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] },
    { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] },
    { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] },
    { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] },
    { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }
]

// SVG como Data URIs para evitar problemas con archivos estáticos en producción
const selectedMarkerSvg = `<svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_781_41156)">
        <path d="M28 24.6499C28 15.8774 36.0958 29.4999 28 29.4999C19.9042 29.4999 28 15.8774 28 24.6499C28 30.3049 22 21.9999 28 24.6499C33 19.4999 28 30.3049 28 24.6499ZM29 4.83325C39.15 4.83325 48.3333 12.6149 48.3333 24.6499C48.3333 32.6733 41.8808 42.1708 29 53.1666C16.1191 42.1708 9.66663 32.6733 9.66663 24.6499C9.66663 12.6149 18.85 4.83325 29 4.83325Z" fill="#E72222"/>
        <path d="M27.2122 17.7385C23.3879 18.1007 20.2387 19.7029 18.6488 22.0908C17.2369 24.2148 17.0712 26.6641 18.1884 28.9415C19.5328 31.6978 22.6328 33.5639 26.6352 34.0366C27.6603 34.1594 29.7045 34.1594 30.7174 34.0366C33.578 33.699 36.1378 32.6493 37.6172 31.2005L38.0469 30.7831L37.1138 30.7647L36.1808 30.7463L35.6222 31.1698C34.3699 32.1275 32.8475 32.7168 30.9138 33.0053C29.9009 33.1526 27.6481 33.1526 26.6352 33.0053C22.0435 32.3239 19.2197 29.6413 19.2136 25.9643C19.2136 25.1049 19.3118 24.5585 19.6003 23.8342C20.7728 20.906 24.2473 18.7514 28.0225 18.6163C29.06 18.5734 29.238 18.6041 29.238 18.8005C29.238 18.9847 29.0845 19.2241 28.354 20.1571C26.6045 22.3977 24.3885 25.6082 23.836 26.7009C23.1423 28.0821 23.4983 29.2976 24.7813 29.8991C25.5671 30.2675 25.5487 30.2675 32.1538 30.249C39.1212 30.2306 38.4275 30.2982 38.9738 29.537C39.3422 29.0275 39.6245 28.389 39.8394 27.5665C39.9806 27.0508 39.999 26.8482 39.999 25.9643C40.0051 25.0619 39.9867 24.89 39.8455 24.356C39.2194 22.0478 37.4822 20.0957 34.9223 18.8373C34.5233 18.6348 34.1612 18.4751 34.1243 18.4751C34.0568 18.4751 33.6394 19.0767 33.6516 19.1688C33.6516 19.1995 33.8849 19.3346 34.1612 19.4696C36.1501 20.4272 37.4944 21.9373 38.0469 23.8465C38.5134 25.4548 38.3354 27.5603 37.6847 28.1558L37.4637 28.3583H32.694C29.4712 28.3583 27.8384 28.3338 27.6788 28.2908C27.5498 28.254 27.3718 28.1558 27.292 28.0698C27.0649 27.8488 27.114 27.4069 27.4332 26.7746C27.9673 25.7187 29.7598 23.208 31.9144 20.5009C33.2588 18.8128 33.2281 18.8619 33.2281 18.6225C33.2281 18.2173 32.7554 18.0147 31.3558 17.8245C30.5394 17.714 28.0164 17.6648 27.2122 17.7385Z" fill="white"/>
    </g>
    <defs>
        <clipPath id="clip0_781_41156">
            <rect width="58" height="58" fill="white"/>
        </clipPath>
    </defs>
</svg>`;

const defaultMarkerSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="6" fill="#EB0A1E"/>
    <circle cx="16" cy="16" r="16" fill="#EB0A1E" fill-opacity="0.2"/>
</svg>`;

const selectedIcon = {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(selectedMarkerSvg)}`,
};

const defaultIcon = {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(defaultMarkerSvg)}`,
};

function MapContent({ mapState, onItemClick, dealerships }) {
    return (
        <LoadScript
            googleMapsApiKey={process.env.GOOGLE_MAPS_V3_APIKEY}
        >
            <GoogleMap
                mapContainerStyle={containerStyle}
                zoom={mapState.mapConfig.zoom}
                center={mapState.centerAt.coords}
                selectedMarker={mapState.selectedMarker}
                options={{
                    styles: styledMap,
                    minZoom: 4,
                    maxZoom: 18,
                    fullscreenControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                }}
            >
                {
                    dealerships.map((dealer, index) => {
                        const lat = Number(dealer.coords.lat)
                        const lng = Number(dealer.coords.lng)
                        const position = {
                            lat: lat,
                            lng: lng,
                        }
                        return (
                            <Marker
                                key={index}
                                position={position}
                                icon={mapState.selectedMarker == dealer ? selectedIcon : defaultIcon}
                                onClick={(e) => onItemClick(e, dealer)}
                            />
                        )
                    })
                }
            </GoogleMap>
        </LoadScript>
    )
}

export default React.memo(MapContent)